export default {"src":"/_next/static/media/logo.3e26937e.svg","height":100,"width":178};